<template>
  <div class="converage">
    <div class="search">
      <span>图层管理</span>
      <div class="condition">
        <el-select v-model="currentTc" placeholder="请选择地图" style="margin-right: 20px" @change="getList">
          <el-option label="数据大屏" :value="1"></el-option>
          <el-option label="预约管理" :value="31"></el-option>
          <el-option label="采伐证审批" :value="32"></el-option>
          <el-option label="集材厂/加工厂审核" :value="35"></el-option>
          <el-option label="伐区列表" :value="12"></el-option>
          <el-option label="林木销售" :value="13"></el-option>
          <el-option label="经营入库台账" :value="22"></el-option>
          <el-option label="经营出库台账" :value="23"></el-option>
          <el-option label="巡护记录" :value="72"></el-option>
          <el-option label="事件管理" :value="41"></el-option>
          <el-option label="处罚记录" :value="43"></el-option>
          <el-option label="林长巡林" :value="83"></el-option>
          <el-option label="核查任务" :value="92"></el-option>
          <el-option label="集材厂/加工厂" :value="21"></el-option>
          <el-option label="上报管理" :value="45"></el-option>
          <el-option label="App黑名单" :value="46"></el-option>
          <!-- <el-option label="App保护区查询" :value="47"></el-option>
          <el-option label="App公益林" :value="48"></el-option> -->
        </el-select>
        <el-button type="success" @click="openAdd">新增</el-button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" v-loading="loading" element-loading-text="数据加载中..." height="700px" align="center" :header-cell-style="{ background: '#f4f7fe' }">
        <el-table-column prop="name" label="图层名称"></el-table-column>
        <el-table-column prop="type" label="图层类型">
          <template slot-scope="scope">
            <span>{{ scope.row.type == 1 ? '底图' : '矢量图层' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="baseId" label="图层地址/图层ID"></el-table-column>
        <el-table-column prop="state" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.state == 0">开启</el-tag>
            <el-tag type="info" v-if="scope.row.state == 1">关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="right">
          <template slot-scope="scope">
            <el-button @click="rowDetail(scope.row)" type="success" size="small">修改</el-button>
            <el-button @click="closeDate(scope.row, 1)" type="success" size="small" v-if="scope.row.state == 0">关闭</el-button>
            <el-button @click="closeDate(scope.row, 2)" type="success" size="small" v-if="scope.row.state == 1">开启</el-button>
            <el-button @click="deleteRowData(scope.row)" type="success" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50]"
        layout="sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 新增、编辑弹窗 -->
    <el-dialog :title="currentType == 'add' ? '新增图层' : '编辑图层'" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
      <el-form class="margin-top-sm" ref="tcForm" :model="tcForm" label-width="100px" :rules="rules">
        <el-form-item label="图层名" prop="name">
          <el-input v-model="tcForm.name"></el-input>
        </el-form-item>
        <div v-if="currentType == 'add'">
          <el-form-item label="图层类型" prop="type">
            <el-select v-model="tcForm.type" placeholder="请选择" style="width: 100%">
              <el-option label="底图" :value="1"></el-option>
              <el-option label="矢量图层" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图层地址" prop="baseUrl" v-if="tcForm.type == '1'">
            <el-input v-model="tcForm.baseUrl"></el-input>
          </el-form-item>
          <el-form-item label="图层" prop="baseId" v-if="tcForm.type == '2'">
            <el-cascader ref="cascaderAddr" style="width: 100%" v-model="tcForm.baseId" :options="layerList" placeholder="请选择图层" :show-all-levels="false"></el-cascader>
          </el-form-item>
        </div>
        <el-form-item label="排列顺序" prop="index">
          <el-input type="number" v-model="tcForm.index"></el-input>
        </el-form-item>
        <el-form-item label="是否显示" prop="isShow">
          <el-radio v-model="tcForm.isShow" :label="true">是</el-radio>
          <el-radio v-model="tcForm.isShow" :label="false">否</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="success" @click="addTc" :loading="loading2" v-if="currentType == 'add'">确 定</el-button>
        <el-button type="success" @click="editTc" :loading="loading2" v-if="currentType == 'edit'">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { GetLayerManageLis, GetLayerManageDetails, AddLayersManage, UpdateLayerManage, DeleteLayerManage, SetLayerState } from '../../api/Map.js'
  import { GetAllMapDocAndLayer } from '@/assets/api/home-api'
  export default {
    name: 'converage',
    data() {
      return {
        currentTc: null, //当前选中地图层
        loading: false, // 数据是否处于加载状态
        loading2: false,
        tableData: [], // 表格数据
        total: 0, // 数据总数
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前查询数据个数
        dialogVisible: false, // 对话框是否显示
        tcForm: {
          name: '',
          type: 1,
          isShow: true,
          index: 0,
          baseUrl: '',
          baseId: [],
        },
        currentType: 'add',
        rules: {
          name: [{ required: true, message: '请填写图层名', trigger: 'blur' }],
          baseUrl: [{ required: true, message: '请填写图层地址', trigger: 'blur' }],
        },
        layerList: [],
        editID: null,
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      },
    },
    mounted() {
      this.getList()
      GetAllMapDocAndLayer().then((res) => {
        if (res.data.Status == 1) {
          this.layerList = JSON.parse(res.data.Data)
        }
      })
    },
    methods: {
      // 打开新增图层
      openAdd() {
        if (this.currentTc == null) {
          return this.$message.warning('请先选择地图再添加图层')
        }
        this.dialogVisible = true
      },
      // 分页查询
      handleSizeChange(e) {
        this.pageSize = e
        this.getList()
      },
      handleCurrentChange(e) {
        this.currentPage = e
        this.getList()
      },
      /*获取所有数据列表 */
      async getList() {
        this.loading = true
        try {
          let params = {
            pageNumber: this.currentPage,
            pageSize: this.pageSize,
            uId: this.currentTc,
          }
          let { data } = await GetLayerManageLis(params)
          if (data.state === 1) {
            data = data.data
            this.tableData = data.lis
            this.total = data.count
            this.loading = false
          } else {
            this.loading = false
            this.$message.error(data.msg)
          }
        } catch (err) {
          // this.$message.error("获取采伐证列表列表失败,请稍后重试!");
        }
      },

      /* 数据详情 */
      rowDetail(row) {
        GetLayerManageDetails(row.id).then((res) => {
          if (res.data.state == 1) {
            this.tcForm.name = res.data.data.name
            this.tcForm.index = res.data.data.index
            this.tcForm.isShow = res.data.data.isShow
          }
        })
        this.editID = row.id
        this.currentType = 'edit'
        this.dialogVisible = true
      },
      // 关闭新增
      handleClose() {
        this.$refs.tcForm.resetFields()
        this.editID = null
        this.currentTc = null
        this.dialogVisible = false
        this.currentType = 'add'
      },
      // 新增图层
      addTc() {
        const that = this
        this.$refs['tcForm'].validate((valid) => {
          if (valid) {
            that.loading2 = true
            if (that.tcForm.type == 2 && that.tcForm.baseId.length == 0) {
              return that.$message.warning('请选择图层')
            }
            let params = {}
            let arr = []
            if (that.tcForm.type == 1) {
              params = {
                type: that.tcForm.type,
                name: that.tcForm.name,
                index: parseInt(that.tcForm.index),
                baseId: that.tcForm.baseUrl,
                isShow: that.tcForm.isShow,
                uId: that.currentTc,
              }
            } else {
              params = {
                type: that.tcForm.type,
                name: that.tcForm.name,
                index: parseInt(that.tcForm.index),
                baseId: that.tcForm.baseId[1] + '',
                isShow: that.tcForm.isShow,
                uId: that.currentTc,
              }
            }
            AddLayersManage(params).then((res) => {
              if (res.data.state == 1) {
                that.$message.success('添加成功')
                that.handleClose()
                that.getList()
              } else {
                that.$message.warning(res.data.msg)
              }
              that.loading2 = false
            })
          }
        })
      },
      // 编辑图层
      editTc() {
        const that = this
        this.$refs['tcForm'].validate((valid) => {
          if (valid) {
            that.loading2 = true
            let params = {
              id: that.editID,
              name: that.tcForm.name,
              index: parseInt(that.tcForm.index),
              isShow: that.tcForm.isShow,
            }
            UpdateLayerManage(params).then((res) => {
              if (res.data.state == 1) {
                that.$message.success('修改成功')
                that.handleClose()
                that.getList()
              } else {
                that.$message.warning(res.data.msg)
              }
              that.loading2 = false
            })
          }
        })
      },
      // 关闭开启图层
      closeDate(row) {
        this.$confirm(`确定${row.state == 0 ? '关闭' : '开启'}？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            SetLayerState(row.id).then((res) => {
              if (res.data.state == 1) {
                this.$message.success('操作成功')
                this.getList()
              } else {
                this.$message.erroe(res.data.msg)
              }
            })
          })
          .catch(() => {})
      },
      /* 通过ID删除单行数据 */
      deleteRowData(row) {
        this.$confirm('确定删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            DeleteLayerManage(row.id).then((res) => {
              if (res.data.state == 1) {
                this.$message.success('操作成功')
                this.getList()
              } else {
                this.$message.erroe(res.data.msg)
              }
            })
          })
          .catch(() => {})
      },
    },
  }
</script>
<style lang="less" scoped>
  .converage {
    height: 100%;
    .search {
      padding: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        font-size: 20px;
        font-weight: bold;
      }
      .condition {
        display: flex;
        align-items: center;
      }
    }
    .table {
      padding: 0px 30px 0px 30px;
    }
    .page {
      text-align: center;
    }
    /deep/ .el-dialog__header {
      padding: 10px;
      background-color: #5bacf0;
    }
    /deep/ .el-dialog__title {
      color: #fff;
    }
    /deep/ .el-dialog__body {
      padding: 15px;
    }
    /deep/ .el-dialog__footer {
      padding: 0px 10px 10px 10px;
    }
    /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #fff !important;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
  }
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }

  /deep/ input::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
  }
  /deep/ input[type='number'] {
    -moz-appearance: textfield;
  }
</style>

